import React, { Component } from 'react'
import { Table, Row, Col, Avatar, Modal, Icon } from 'antd'
import { FormattedNumber } from 'react-intl'
import localeGet from '~/App/utils/localeGet'
import setQuestionOptionName from '~/App/utils/setQuestionOptionName'
import _get from 'lodash/get'
const optionFieldMap = {
  Open: 'value',
  Choice: 'itemId',
  MultiChoice: 'itemIds'
}
class ExtraItems extends Component {
  imageModal ({productName, productImageUrl, record}) {
    Modal.info({
      title: productName,
      className: 'imageModal',
      content: (
        <div>
          <ul>
            {_get(record, 'options', []).map(option =>
              <li>{option.question.name.en}: {_get(option, optionFieldMap[option.question.kind], '')}</li>
            )}
          </ul>
          <img src={productImageUrl} alt="payment" />
        </div>
      ),
      onOk () {}
    })
  }
  render () {
    const {items, locale, event} = this.props
    return <Table dataSource={items} pagination={false} rowKey="_id">
      <Table.Column title="รายการสินค้า" key="product"
        render={record => {
          const productName = localeGet(record, 'product.name', locale)
          const productImageUrl = _get(record, 'product.imageUrl')
          return <Row>
            <Col xs={24} sm={14} style={{color: 'blue'}} onClick={() => this.imageModal({productName, productImageUrl, record})}>
              <Avatar shape="square" src={productImageUrl} />{'  '}
              {productName}{' '}
              <Icon type="eye" />
            </Col>
            <Col xs={24} sm={5}>
              <span><b>ราคา</b> <FormattedNumber value={record.product.price * record.quantity} minimumFractionDigits={2} /> บาท</span>
            </Col>
            <Col xs={24} sm={5}><span><b>จำนวน</b> {record.quantity} ชิ้น</span></Col>
            <Col xs={18} sm={5}>
              <ul>
                {_get(record, 'options', []).map(option => {
                  if (_get(option, 'question.inputType') === 'shirtTypes') {
                    return (<li>
                      {localeGet(option, 'question.name', locale)}:{' '}
                      {localeGet(event.shirtTypes.find(st => st._id === option.shirtTypeId), 'name', locale)},&nbsp;
                      {localeGet(event.shirts.find(s => s._id === option.shirtId), 'name', locale)}
                    </li>)
                  }
                  let value = _get(option, optionFieldMap[option.question.kind], '')
                  value = setQuestionOptionName({kind: option.question.kind, value, items: _get(option, 'question.items'), locale})
                  return <li>{localeGet(option, 'question.name', locale)}: {value}</li>
                })}
              </ul>
            </Col>
          </Row>
        } }/>
    </Table>
  }
}

export default ExtraItems



// WEBPACK FOOTER //
// ./src/App/components/ExtraItems/ExtraItems.js